// Register custom element only if not already defined
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer")) {
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        }

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;

              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");

            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty")) {
              this.cart.classList.remove("is-empty");
            }
            if (!this.error) {
              this.submitButton.removeAttribute("aria-disabled");
            }
            this.querySelector(".loading__spinner").classList.add("hidden");

            // Mini-cart upsell slider
            $(".mini-cart-may-like-cntnr .product-list").slick({
              dots: false,
              infinite: true,
              speed: 300,
              slidesToShow: 1,
              slidesToScroll: 1,
            });
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

// Cache management utilities
const CACHE_KEYS = {
  PRODUCT_DATA: "cs_product_data",
  PRODUCT_TIMESTAMP: "cs_product_timestamp",
};

const CACHE_DURATIONS = {
  PRODUCT: 60 * 60 * 1000, // 1 hour in milliseconds
};

function isCacheValid(timestamp, duration) {
  if (!timestamp) return false;
  const now = Date.now();
  return now - timestamp < duration;
}

function getCachedData(key, timestampKey) {
  try {
    const data = localStorage.getItem(key);
    const timestamp = localStorage.getItem(timestampKey);

    if (data && timestamp) {
      const duration = CACHE_DURATIONS.PRODUCT;
      if (isCacheValid(parseInt(timestamp), duration)) {
        return JSON.parse(data);
      }
    }
  } catch (error) {
    console.error("Error reading from cache:", error);
  }
  return null;
}

function setCachedData(key, timestampKey, data) {
  try {
    localStorage.setItem(key, JSON.stringify(data));
    localStorage.setItem(timestampKey, Date.now().toString());
  } catch (error) {
    console.error("Error writing to cache:", error);
  }
}

// Simple cart data fetching function - always fresh data
let cartPromise2 = null;

function getCartData() {
  // Return existing promise if a request is already in progress
  if (cartPromise2) {
    return cartPromise2;
  }

  // Create new promise for cart data using Shopify's /cart.js API
  cartPromise2 = fetch("/cart.js")
    .then(function (response) {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(function (cartData) {
      return cartData;
    })
    .catch(function (error) {
      console.error("Error fetching cart data:", error);
      // Return default USD data on error
      return { currency: "USD" };
    })
    .finally(function() {
      // Reset promise so next call fetches fresh data
      cartPromise2 = null;
    });

  return cartPromise2;
}

// Product data caching function
function getProductData() {
  // Check localStorage cache first
  const cachedData = getCachedData(
    CACHE_KEYS.PRODUCT_DATA,
    CACHE_KEYS.PRODUCT_TIMESTAMP
  );
  if (cachedData) {
    return Promise.resolve(cachedData);
  }

  // Fetch fresh data if not cached
  return fetch("https://carrotstick.com/products/inveterate-subscription.json")
    .then((response) => response.json())
    .then((data) => {
      // Cache the response
      setCachedData(
        CACHE_KEYS.PRODUCT_DATA,
        CACHE_KEYS.PRODUCT_TIMESTAMP,
        data
      );
      return data;
    })
    .catch((error) => {
      console.error("Error fetching product data:", error);
      throw error;
    });
}

// DOM Ready price grab (cleaned) with caching
document.addEventListener("DOMContentLoaded", function () {
  
  // Use cached product data
  getProductData()
    .then((data) => {
      const rawPrice = parseFloat(data.product.variants[0].price);

      const price =
        rawPrice % 1 === 0 ? rawPrice.toFixed(0) : rawPrice.toFixed(2);
      const priceCurrency = data.product.variants[0].price_currency;
      let vipprice = priceCurrency + " " + price;

      let isSubscribed = localStorage.getItem("inverrate_subscribed");
      let isVip_added = localStorage.getItem("vip_added");

      getCartData().then(function (cartData) {
        let productPrice = jQuery("#product-price").val();

        if (productPrice) {
          productPrice = productPrice.replace(/[^0-9.]/g, "");
          productPrice = parseFloat(productPrice);

          if (!isNaN(productPrice)) {
            let discountedPrice = (
              productPrice -
              (productPrice * 15) / 100
            ).toFixed(2);

            let currencyIcon = "";
            switch (cartData.currency) {
              case "INR":
                currencyIcon = "INR";
                break;
              case "EUR":
                currencyIcon = "€";
                break;
              case "AUD":
                currencyIcon = "A$";
                break;
              case "GBP":
                currencyIcon = "£";
                break;
              case "CAD":
                currencyIcon = "C$";
                break;
              default:
                currencyIcon = "$";
            }

            let Attached_name = jQuery(
              ".rtx-subscription .widget label input" 
            ).attr("name");

            let vipprice = currencyIcon + " " + discountedPrice;

            let subscriptionBlock = `
          <label for="purchaseTypeOneTime-78508997674631" class="rtx-purchase-label">
            <div class="purchase-label onetime">
              <div class="rtx-purchase-label__inner">
                <input type="radio" id="purchaseTypeOneTime-78508997674631" name="${Attached_name}" value="vip_member_product" data_plan="custom" class="vip-input">
                <div style="margin-left:10px;">VIP Member Price</div>
              </div>
              <div id="product-price-display">${currencyIcon}${discountedPrice}</div>
            </div>
            <ul class="deluxe-gift-list">
              <li><svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="9"><path d="M10.5 0L4.5 6.5L1.5 3L0.5 4L4.5 8.5L11.5 1L10.5 0Z" fill="#FAC463"></path></svg> Free 30d trial.</li>
              <li><svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="9"><path d="M10.5 0L4.5 6.5L1.5 3L0.5 4L4.5 8.5L11.5 1L10.5 0Z" fill="#FAC463"></path></svg> 15% off today.</li>
              <li><svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="9"><path d="M10.5 0L4.5 6.5L1.5 3L0.5 4L4.5 8.5L11.5 1L10.5 0Z" fill="#FAC463"></path></svg> After your 30-day free trial, it's ${vipprice}/mo.</li>
              <li><svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="9"><path d="M10.5 0L4.5 6.5L1.5 3L0.5 4L4.5 8.5L11.5 1L10.5 0Z" fill="#FAC463"></path></svg> You get ${vipprice} credit each month.</li>
              <li><svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="9"><path d="M10.5 0L4.5 6.5L1.5 3L0.5 4L4.5 8.5L11.5 1L10.5 0Z" fill="#FAC463"></path></svg> Use within 12m.</li>
            </ul>
          </label>
        `;

            // if (cartData && cartData.currency !== "USD") {

            //   console.log("Not in USD");
            //   // jQuery(".rtx-subscription .widget").append(subscriptionBlock);
            //   // jQuery(".rtx-subscription .widget").eq(1).append(subscriptionBlock);

            //   if (jQuery(".rtx-subscription .widget").length > 1) {
            //     // Append to the second widget if it exists
            //     jQuery(".rtx-subscription").eq(0).hide();
            //     jQuery(".rtx-subscription .widget").eq(1).append(subscriptionBlock);
            //     console.log("Appended to second widget.");
            //   } else {
            //     // Otherwise, append to the first widget
            //     jQuery(".rtx-subscription .widget").eq(0).append(subscriptionBlock);
            //     console.log("Appended to first widget.");
            //   }

            //   jQuery("#product-price-display").text(
            //     currencyIcon + discountedPrice
            //   );
            // }
          }
        }
      });
    })
    .catch((error) => {
      console.error("Error loading product data:", error);
    });
});

// Slick carousel handling based on radio input selection
$(function () {
  const $radio = $("#purchaseTypeOneTime-78508997674631");
  const $label = $radio.closest("label");
  const $giftList = $label.find(".deluxe-gift-list");

  if ($radio.is(":checked")) {
    $giftList.addClass("open");
  } else {
    $giftList.removeClass("open");
  }
});

$(document).on("change", "input[type=radio]", function () {
  const $clickedRadio = $(this);
  const name = $clickedRadio.attr("name");

  $('input[name="' + name + '"]').each(function () {
    $(this).closest("label").find(".deluxe-gift-list").removeClass("open");
  });

  if ($clickedRadio.is(":checked")) {
    $clickedRadio.closest("label").find(".deluxe-gift-list").addClass("open");
  }
});

$(document).on("click", ".vip-input", function () {
  const radioGroup = $(`input[type="radio"]`);

  const oneTimeRadio = radioGroup.first();

  // Step 1: Trigger the click on the One-Time Purchase radio
  oneTimeRadio.trigger("click");

  // Step 2: Set VIP input as checked after a short delay
  setTimeout(function () {
    $("#purchaseTypeOneTime-78508997674631")
      .prop("checked", true)
      .trigger("change");
  }, 50);
});

$(document).on(
  "change",
  '.rtx-subscription .purchase-label input[type="radio"]',
  function () {
    const val = $(this).val();

    // Use cached product data
    getProductData()
      .then((data) => {
        const price = data.product.variants[0].price;
        const priceCurrency = data.product.variants[0].price_currency;
        let vipprice = priceCurrency + " " + price;

        getCartData().then(function (cartData) {
          let productPrice = jQuery("#product-price").val();

          if (productPrice) {
            productPrice = productPrice.replace(/[^0-9.]/g, "");
            productPrice = parseFloat(productPrice);

            if (!isNaN(productPrice)) {
              let discountedRawPrice = productPrice - (productPrice * 15) / 100;

              let discountedPrice =
                discountedRawPrice % 1 === 0
                  ? discountedRawPrice.toFixed(0)
                  : discountedRawPrice.toFixed(2);

              let currencyIcon = "";
              switch (cartData.currency) {
                case "INR":
                  currencyIcon = "INR";
                  break;
                  case "EUR":
                  currencyIcon = "€";
                  break;
                case "AUD":
                  currencyIcon = "A$";
                  break;
                case "GBP":
                  currencyIcon = "£";
                  break;
                case "CAD":
                  currencyIcon = "C$";
                  break;
                default:
                  currencyIcon = "$";
              }

              let Attached_name = jQuery(
                ".rtx-subscription .widget label input"
              ).attr("name");

              let vipprice = currencyIcon + " " + discountedPrice;

              let subscriptionBlock = `
            <label for="purchaseTypeOneTime-78508997674631" class="rtx-purchase-label">
              <div class="purchase-label onetime">
                <div class="rtx-purchase-label__inner">
                  <input type="radio" id="purchaseTypeOneTime-78508997674631" name="${Attached_name}" value="vip_member_product" data_plan="custom" class="vip-input">
                  <div style="margin-left:10px;">VIP Member Price</div>
                </div>
                <div id="product-price-display">${currencyIcon}${discountedPrice}</div>
              </div>
              <ul class="deluxe-gift-list">
                <li><svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="9"><path d="M10.5 0L4.5 6.5L1.5 3L0.5 4L4.5 8.5L11.5 1L10.5 0Z" fill="#FAC463"/></svg> Free 30d trial.</li>
                <li><svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="9"><path d="M10.5 0L4.5 6.5L1.5 3L0.5 4L4.5 8.5L11.5 1L10.5 0Z" fill="#FAC463"/></svg> 15% off today.</li>
                <li><svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="9"><path d="M10.5 0L4.5 6.5L1.5 3L0.5 4L4.5 8.5L11.5 1L10.5 0Z" fill="#FAC463"/></svg> After your 30-day free trial, it's ${vipprice}/mo.</li>
                <li><svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="9"><path d="M10.5 0L4.5 6.5L1.5 3L0.5 4L4.5 8.5L11.5 1L10.5 0Z" fill="#FAC463"/></svg> You get ${vipprice} credit each month.</li>
                <li><svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="9"><path d="M10.5 0L4.5 6.5L1.5 3L0.5 4L4.5 8.5L11.5 1L10.5 0Z" fill="#FAC463"/></svg> Use within 12m.</li>
              </ul>
            </label>
          `;

              // Replace with your actual check value if needed
              let val = jQuery("input.vip-input:checked").val();

              if (cartData.currency === "CAD") {
                if (
                  val === "purchaseTypeOneTime-7850899767463" ||
                  val === "vip_member_product"
                ) {
                  if (
                    jQuery(
                      '.rtx-subscription .widget input[value="vip_member_product"]'
                    ).length === 0
                  ) {
                    jQuery(".rtx-subscription .widget").append(
                      subscriptionBlock
                    );
                  }

                  jQuery("#product-price-display").text(
                    currencyIcon + discountedPrice
                  );
                } else {
                  jQuery(".rtx-subscription .widget")
                    .find('input[value="vip_member_product"]')
                    .closest(".rtx-purchase-label")
                    .remove();
                }
              }
            }
          }
        });
      })
      .catch((error) => {
        console.error("Error loading product data:", error);
      });
  }
);

// <li><svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="9"><path d="M10.5 0L4.5 6.5L1.5 3L0.5 4L4.5 8.5L11.5 1L10.5 0Z" fill="#FAC463"></path></svg> Easily pause or cancel online.</li>
// <li><svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="9"><path d="M10.5 0L4.5 6.5L1.5 3L0.5 4L4.5 8.5L11.5 1L10.5 0Z" fill="#FAC463"></path></svg> Easily pause or cancel online.</li>
